import { useState } from "react";
import { Link } from "react-router-dom";
import about from "../../assets/images/about/about-3.jpg";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import ModalVideo from "react-modal-video";
import "../../../node_modules/react-modal-video/scss/modal-video.scss";

export const AboutImage = ({ colClass }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <div className={colClass}>
      <div className="position-relative">
        {/* <div className="play-icon ">
          <Link
            to="#"
            onClick={() => setOpen(true)}
            className="play-btn lightbox video-play-icon"
          >
            <i className="mdi mdi-play text-primary rounded-circle shadow"></i>
          </Link>
        </div> */}

        <video
          src={"https://go-safe-assets.s3.us-east-2.amazonaws.com/intro.mp4"}
          controls
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
};
